import script from "./ContratoCompraForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ContratoCompraForm.vue?vue&type=script&setup=true&lang=js"

import "./ContratoCompraForm.vue?vue&type=style&index=0&id=660c356e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-660c356e"]])

export default __exports__